import vertical_highlight from './vertical_highlight.svg';

export const highlights = {
  vertical_highlight,
};
